<template>
  <div class="member-edit">
    <Modal v-if="showModal" v-bind:modalTitle="$t('group.memberEditForm.modal.header')" @close="closeModal">
      <div class="mod-role-modal">
        <p class="modal-text">{{ $t('group.memberEditForm.modal.text') }}</p>
        <a v-on:click.prevent="modRole" class="button" href="#">{{ $t("group.memberEditForm.modal.button") }}</a>
      </div>
    </Modal>

    <select
      class="role"
      v-model="role"
      v-on:change="showModal = true"
    >
      <option disabled value="">{{ $t("group.memberEditForm.placeholder") }}</option>
      <option v-for="(option, oIdx) in options" v-bind:value="option.value">{{ option.text }}</option>
    </select>
  </div>
</template>

<script>
import Modal from '@/components/Modal.vue'

import { groupService } from '@/services/group.service'

export default {
  name: 'GroupEditForm',
  props: ['groupId', 'appUserId', 'defaultRole'],
  components: {
    Modal
  },
  data: function () {
    return {
      role: this.defaultRole,
      options: [
        { text: this.$t("group.memberEditForm.select.item01"), value: 0 },
        { text: this.$t("group.memberEditForm.select.item02"), value: 1 }
      ],
      showModal: false,
      preRole: this.defaultRole
    }
  },
  methods: {
    modRole: function (event) {
      groupService.modMember(this.groupId, this.appUserId, this.role).then(() => {
          this.showModal = false
          this.preRole = this.role
          this.$router.go(0)
        })
        .catch(err => {
          console.error('Ownership not changed: ', err)
        })
    },
    closeModal: function (event) {
        this.showModal = false
        this.role = this.preRole
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
select {
  flex: 0 1 auto;
  margin: 0 12px 0 0;
  background: none;
}
.mod-role-modal{
  padding: 0 0 25px 0;
}
.modal-text {
  font-weight: bold;
}
</style>
